import React, { Component } from "react";
import PropTypes from "prop-types";
import LinesEllipsis from "react-lines-ellipsis";
import moment from "moment";
import { Button, OverlayTrigger, Tooltip, Badge, Image } from "react-bootstrap";
import _ from "lodash";

// Redux
import { connect } from "react-redux";
import * as actions from "../../redux/actions";

// Component
import Icon from "../../components/Icon";
import InputNumber from "../../components/InputNumber";
import ImageLightbox from "../../components/ImageLightbox";

// Styles
import MenuCardStyled from "./style";
import Color from "../../assets/color";

// Helper
import { weekdays } from "../../helpers/Constant";

class MenuCard extends Component {
  constructor(props) {
    super(props);

    this.state = {
      modalOptionVisible: false,
      modalMenuDetailVisible: false,
      lightboxVisible: false,
    };
  }

  checkOrderTypeAvailable = () => {
    const { data, orderType } = this.props;

    if (orderType === "delivery" && data.allow_delivery) {
      return true;
    } else if (orderType === "dine-in" && data.allow_dinein) {
      return true;
    } else if (orderType === "pick-up" && data.allow_pickup) {
      return true;
    }

    return false;
  };

  /* Menu Detail */
  _showMenuDetail = (e) => {
    e.stopPropagation();
    const { data, onClick } = this.props;
    if (onClick !== undefined) {
      this.props.onClick();
    } else {
      this.props.onShowMenuDetail(data.item_id);
    }
  };

  _hideMenuDetail = () => {
    this.setState({ modalMenuDetailVisible: false });
  };
  /* Menu Detail */

  /* Render */
  _renderPrice = () => {
    const { data, orderType } = this.props;

    let max_price = _.max([
      parseFloat(data.item_price),
      parseFloat(data.delivery_price),
    ]).toFixed(2);

    let price =
      orderType === null
        ? max_price
        : orderType !== "delivery"
        ? data.item_price
        : data.delivery_price;

    return (
      <div className="price">
        {data.discount === 0 && <span className="selling">RM {price}</span>}
        {data.discount === 1 && (
          <React.Fragment>
            <span className="selling">
              {`RM ${_.round(
                (_.round(parseFloat(price) * 100) *
                  (100 - parseFloat(data.discount_pct))) /
                  10000,
                2
              ).toFixed(2)}`}
            </span>
            <span className="original">
              RM
              {price}
            </span>
          </React.Fragment>
        )}
      </div>
    );
  };
  /* END Render */

  _showLightbox = (e) => {
    e.stopPropagation();
    this.setState({ lightboxVisible: true });
  };
  _hideLightbox = (e) => {
    e.stopPropagation();
    this.setState({ lightboxVisible: false });
  };

  render() {
    const {
      firstItem,
      data,
      orderType,
      showOption,
      restaurantServingPeriod,
      itemID,
      value,
      addToCart,
      showDescription,
      showServingPeriod,
      showDiscount,
      showOrderButton,
      openNow,
      preorder,
      isLoggedIn,
      key,
      popoverShow,
      popoverText,
      hideOverlay,
    } = this.props;
    const { lightboxVisible } = this.state;

    let productOrderTypeAvailable = this.checkOrderTypeAvailable();

    let food_tag = [];
    let serving_period = [];
    let gallery = [];

    if (JSON.stringify(data) !== JSON.stringify({})) {
      // Food Tag
      try {
        food_tag = JSON.parse(data.food_tag);
      } catch (error) {
        // console.log("Error: Fail to parse food tag: " + error);
      }
    }

    if (restaurantServingPeriod !== undefined) {
      if (
        JSON.stringify(restaurantServingPeriod) !==
        JSON.stringify(data.ItemMenuServingPeriods)
      ) {
        data.ItemMenuServingPeriods.forEach((data) => {
          let time =
            moment(data.open_tms, "HH:mm:ss").format("hh:mm A") +
            " - " +
            moment(data.close_tms, "HH:mm:ss").format("hh:mm A");

          let selected = serving_period.findIndex((x) => x.time === time);

          if (selected === -1) {
            serving_period.push({
              time: time,
              days: [weekdays[data.working_day].abbr],
            });
          } else {
            serving_period[selected].days.push(weekdays[data.working_day].abbr);
          }
        });
      }

      if (
        data.profile_thumbnail !== null &&
        data.profile_thumbnail !== undefined
      ) {
        gallery.push({
          src: data.profile_thumbnail,
          caption: (
            <div className="menu-caption">
              <div className="item-name">{data.item_name}</div>
              <div>{this._renderPrice()}</div>
            </div>
          ),
        });
      } else {
        gallery.push({
          src: data.profile_pic,
          caption: (
            <div className="menu-caption">
              <div className="item-name">{data.item_name}</div>
              <div>{this._renderPrice()}</div>
            </div>
          ),
        });
      }

      if (data.item_pic) {
        data.item_pic.forEach((pic) => {
          const isThumbnail = gallery.find(
            (x) => x.src === pic.item_img || x.src === pic.thumbnail
          );
          if (!isThumbnail) {
            gallery.push({
              src: pic.item_img,
              caption: (
                <div className="menu-caption">
                  <div className="item-name">{data.item_name}</div>
                  <div>{this._renderPrice()}</div>
                </div>
              ),
            });
          }
        });
      }
    }

    return (
      <MenuCardStyled key={key} className={`${firstItem ? "first" : ""}`}>
        <div className="product-container" onClick={this._showMenuDetail}>
          {data.outOfStock && <div className="invalid" />}
          <div className="image-container" onClick={this._showLightbox}>
            <div className="product-image-wrapper">
              <img
                className="product-image"
                src={
                  data.profile_thumbnail !== null &&
                  data.profile_thumbnail !== undefined
                    ? data.profile_thumbnail
                    : data.profile_pic !== null &&
                      data.profile_pic !== undefined
                    ? data.profile_pic
                    : data.thumbnail_square != null &&
                      data.thumbnail_square !== undefined
                    ? data.thumbnail_square
                    : data.thumbnail != null && data.thumbnail !== undefined
                    ? data.thumbnail
                    : data.item_img != null && data.item_img !== undefined
                    ? data.item_img
                    : "https://static-staging.lolol.com/images/media/default.png"
                  // "https://static-live.lolol.com/images/media/default.png"
                }
                alt=""
              />

              {lightboxVisible && (
                <ImageLightbox
                  images={gallery}
                  onClose={this._hideLightbox}
                  modalStyle={{
                    overlay: {
                      backgroundColor: Color.black,
                    },
                  }}
                />
              )}
              {data.outOfStock && <div className="sold-out">Sold Out</div>}
            </div>
          </div>
          {/* END .image-container */}
          <div className="product-detail">
            <div className="product-info">
              <div className="info">
                <LinesEllipsis
                  text={data.item_name}
                  maxLine="1"
                  ellipsis={<span> ...</span>}
                  trimRight
                  basedOn="letters"
                  component="h5"
                  className="product-name"
                />
                {showDescription !== false && data.item_desc && (
                  <LinesEllipsis
                    text={data.item_desc}
                    maxLine="1"
                    ellipsis={<span> ...</span>}
                    trimRight
                    basedOn="letters"
                    component="p"
                    className="description"
                  />
                )}

                {/* Serving Period */}
                {showServingPeriod && serving_period.length !== 0 && (
                  <React.Fragment>
                    <p className="serving-period">
                      <span>{serving_period[0].days.join()}</span>
                      {": "}
                      <span>{serving_period[0].time}</span>{" "}
                    </p>
                    {serving_period.length > 1 && (
                      <p className="more-serving-period">
                        More Serving Period >
                      </p>
                    )}
                  </React.Fragment>
                )}
                {/* END Serving Period */}

                {/* Discount */}
                {showDiscount && data.discount === 1 && (
                  <div className="discount">
                    <Badge variant="danger">OFF</Badge>
                    <span className="text">
                      {data.discount_pct}% off
                      {data.discount_limit > 0 && (
                        <span> (first {data.discount_limit} items only)</span>
                      )}
                    </span>
                  </div>
                )}
                {/* END Discount */}
                {/* Food Label */}
                <div
                  className="food-label"
                  onClick={(e) => e.stopPropagation()}
                >
                  {!!data.recommended && (
                    <OverlayTrigger
                      key="recommend"
                      placement="top"
                      overlay={<Tooltip id="recommend">Recommended</Tooltip>}
                    >
                      <div className="label">
                        <Image
                          src={require("../../assets/icon/chef.png")}
                          alt=""
                          className="icon-chef"
                        />
                      </div>
                    </OverlayTrigger>
                  )}
                  {food_tag.map((label, index) => {
                    let iconName = label.replace(" ", "").toLowerCase();
                    return (
                      <OverlayTrigger
                        key={iconName}
                        placement="top"
                        overlay={<Tooltip id={iconName}>{label}</Tooltip>}
                      >
                        <div className="label">
                          <Icon
                            type="custom"
                            name={iconName}
                            size={15}
                            color={Color.emperor}
                          />
                        </div>
                      </OverlayTrigger>
                    );
                  })}
                  {/* END Food Label */}
                </div>
              </div>
              {/* Price */}
              <div className="d-none d-md-block">{this._renderPrice()}</div>
              {/* END Price */}
            </div>
            {/* END .product-info */}

            {showOrderButton !== false && (
              <div className="price-order-container">
                {/* Price */}
                <div className="d-md-none">{this._renderPrice()}</div>
                {/* END Price */}

                <div
                  className="order-type"
                  onClick={(e) => e.stopPropagation()}
                >
                  {orderType !== null &&
                  productOrderTypeAvailable &&
                  !data.outOfStock &&
                  (openNow || preorder || orderType === "pick-up") ? (
                    data.option.length === 0 ? (
                      <InputNumber
                        data={data}
                        showOption={showOption}
                        value={isLoggedIn ? value : 0}
                        itemID={itemID}
                        addToCart={addToCart}
                        isLoggedIn={isLoggedIn}
                        popoverShow={popoverShow}
                        popoverText={popoverText}
                        hideOverlay={hideOverlay}
                      />
                    ) : (
                      <div className="btn-option">
                        <Button
                          variant="outline-dark"
                          onClick={
                            isLoggedIn
                              ? (e) => showOption(e, data)
                              : (e) => {
                                  addToCart();
                                }
                          }
                        >
                          Option
                          {isLoggedIn && value > 0 && (
                            <Badge variant="primary">{value}</Badge>
                          )}
                        </Button>
                      </div>
                    )
                  ) : (
                    (orderType === null || openNow || preorder) &&
                    (orderType === null || !data.outOfStock) &&
                    (orderType === null || productOrderTypeAvailable) && (
                      <React.Fragment>
                        <OverlayTrigger
                          key="delivery"
                          placement="top"
                          overlay={
                            <Tooltip id={`tooltip-delivery`}>Delivery</Tooltip>
                          }
                        >
                          <div
                            className={`icon-order-type ${
                              !data.allow_delivery ? "disabled" : ""
                            }`}
                          >
                            <Icon
                              type="custom"
                              name="delivery"
                              color={Color.emperor}
                              size={18}
                            />
                          </div>
                        </OverlayTrigger>
                        <OverlayTrigger
                          key="dinein"
                          placement="top"
                          overlay={
                            <Tooltip id={`tooltip-dinein`}>Dine In</Tooltip>
                          }
                        >
                          <div
                            className={`icon-order-type ${
                              !data.allow_dinein ? "disabled" : ""
                            }`}
                          >
                            <Icon
                              type="custom"
                              name="dinein"
                              color={Color.emperor}
                              size={18}
                            />
                          </div>
                        </OverlayTrigger>
                        <OverlayTrigger
                          key="pickup"
                          placement="top"
                          overlay={
                            <Tooltip id={`tooltip-pickup`}>Pick Up</Tooltip>
                          }
                        >
                          <div
                            className={`icon-order-type ${
                              !data.allow_pickup ? "disabled" : ""
                            }`}
                          >
                            <Icon
                              type="custom"
                              name="pickup"
                              color={Color.emperor}
                              size={18}
                            />
                          </div>
                        </OverlayTrigger>
                      </React.Fragment>
                    )
                  )}
                </div>
              </div>
            )}
            {/* END .order-type */}
          </div>
          {/* END .product-detail */}
        </div>
        {/* END .product-container */}
      </MenuCardStyled>
    );
  }
}

MenuCard.propTypes = {
  data: PropTypes.object.isRequired,
  firstItem: PropTypes.bool,
  orderType: PropTypes.string,
  restaurantServingPeriod: PropTypes.array,
  showDescription: PropTypes.bool,
  showServingPeriod: PropTypes.bool,
  showDiscount: PropTypes.bool,
  showOrderButton: PropTypes.bool,
  // Function
  onLoadMenuDetail: PropTypes.func.isRequired,
  showOption: PropTypes.func,
  onClick: PropTypes.func,
};

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return {
    onLoadMenuDetail: (params) =>
      dispatch(actions.loadRestaurantMenuDetail(params)),
    onShowMenuDetail: (params) => dispatch(actions.showMenuDetailModal(params)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(MenuCard);
